const KEY = "zapiudp_origin";

export function captureOrigin() {
  if (sessionStorage.getItem(KEY)) return;
  const q = new URLSearchParams(window.location.search);
  const origin = {
    source: q.get("utm_source") || q.get("origem") || q.get("ref") || (document.referrer ? "link" : "direto"),
    medium: q.get("utm_medium") || "",
    campaign: q.get("utm_campaign") || q.get("campanha") || "",
    referrer: document.referrer ? new URL(document.referrer).hostname : "",
    landing: window.location.pathname + window.location.search,
  };
  sessionStorage.setItem(KEY, JSON.stringify(origin));
}

export const getOrigin = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || null;
  } catch {
    return null;
  }
};
